module.exports = __webpack_public_path__ + "static/img/naturalCircle6.c9b97ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle6.svg
// module id = 95ry
// module chunks = 1